export function createSteamMarketWorker() {
  return new Worker(new URL("./steamMarketLayout.worker.js", import.meta.url));
}
